import { render, staticRenderFns } from "./IconOfficeOutdoors.vue?vue&type=template&id=84315e50&"
import script from "./IconOfficeOutdoors.vue?vue&type=script&lang=ts&"
export * from "./IconOfficeOutdoors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports